@if (isIE) {
  <div class="ie-banner">
    {{ 'IEBanner' | translate }}
  </div>
}

@if (isLoading && !canDisplay) {
  @if (device.isDesktop()) {
    <inf-full-page-loader />
  } @else {
    <infm-full-page-loader />
  }
} @else {
  <router-outlet />
}
@if (device.isDesktop()) {
  <inf-notifications-container />
} @else {
  <infm-notifications-container />
}

@if (showLoader) {
  @if (device.isDesktop()) {
    <inf-full-page-loader />
  } @else {
    <infm-full-page-loader />
  }
}

<inf-rest-error />
